import { createStore, combineReducers, compose, applyMiddleware, Store } from 'redux';
import thunk from 'redux-thunk';

import { listingReducer, defaultListingState } from './reducers/listing';
import { filterReducer, defaultFilterState } from './reducers/filters';
import { getListing, setProviderImages, setPDFGenerationMessage, setCustomDistanceErrorMessage, setShowDistanceFilter, setEnableAdvanceLocationLookup } from './actions/listing';
import { IAppState } from '../classes/app';
import { responsiveReducer, defaultResponsiveState } from './reducers/responsive';
import { fetchEvents, setSpecialtiesFilter, setProviderDesignationFilter, setZipOrCityFilter, setGenderFilter, setLanguageFilter, setHospitalPracticeFilter, setNetworkFilter, setPrintButton, setCityFilter, setSearchWithinTitle } from './actions/filters';
import * as moment from 'moment';




export const localStoreCacheKey = () => {
    if (document.getElementById("provider-entry-js")) return 'providerState';
    if (document.getElementById("location-entry-js")) return 'locationState';
    if (document.getElementById("generic-entry-js")) return 'genericState';
    if (document.getElementById("event-entry-js")) return 'eventState';
}





export const combinedReducer = combineReducers({
    listingState: listingReducer,
    filtersState: filterReducer,
    responsiveState: responsiveReducer
});

export const loadState = (key: string) => {
    try {
        if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {

            const serializedState = sessionStorage.getItem(key);
            if (serializedState === null) {
                return undefined;
            }

            return JSON.parse(serializedState);
        }
        return undefined;
    } catch (e) {
        return undefined;
    }
};

const saveState = (state, key) => {
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem(key, serializedState);
    } catch (e) {
        // Ignore write errors;
    }
};
// enable redux dev tools use
let composeEnhancers = compose;
if (process.env.NODE_ENV === 'development') {
    /* eslint-disable no-underscore-dangle */
    // @ts-ignore
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    // @ts-ignore
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose;
    /* eslint-enable */
}
const defaultStore = createStore(combinedReducer, composeEnhancers(applyMiddleware(thunk)));

export function initializeDefaultStore(store: Store, dontSearchOnPageLoad?: boolean) {

    if (!dontSearchOnPageLoad)
        store.dispatch(getListing() as any);

    store.dispatch(setProviderImages((window as any).hideProviderImages ? (window as any).hideProviderImages : false));
    store.dispatch(setSpecialtiesFilter((window as any).hideSpecialtiesFilter ? (window as any).hideSpecialtiesFilter : false));
    store.dispatch(setZipOrCityFilter((window as any).hideZipOrCityFilter ? (window as any).hideZipOrCityFilter : false));
    store.dispatch(setGenderFilter((window as any).hideGenderFilter ? (window as any).hideGenderFilter : false));
    store.dispatch(setLanguageFilter((window as any).hideLanguageFilter ? (window as any).hideLanguageFilter : false));
    store.dispatch(setProviderDesignationFilter((window as any).hideProviderDesignationFilter ? (window as any).hideProviderDesignationFilter : false));
    store.dispatch(setHospitalPracticeFilter((window as any).hideHospitalPracticeFilter ? (window as any).hideHospitalPracticeFilter : false));
    store.dispatch(setNetworkFilter((window as any).hideNetworkFilter ? (window as any).hideNetworkFilter : false));
    store.dispatch(setPDFGenerationMessage((window as any).pdfGenerationMessage));
    store.dispatch(setPrintButton((window as any).showProviderPrint ? (window as any).showProviderPrint : false));
    store.dispatch(setCityFilter((window as any).hideCityFilter ? (window as any).hideCityFilter : false));
    if ((window as any).searchWithinTitle) store.dispatch(setSearchWithinTitle((window as any).searchWithinTitle));
    if ((window as any).customDistanceErrorMessage) store.dispatch(setCustomDistanceErrorMessage((window as any).customDistanceErrorMessage));
    store.dispatch(setShowDistanceFilter((window as any).showDistanceFilter ? (window as any).showDistanceFilter : false));
    store.dispatch(setEnableAdvanceLocationLookup((window as any).enableAdvanceLocationLookup ? (window as any).enableAdvanceLocationLookup : false));

    let prevState = store.getState();
    let prevMonth = moment().format("MYYYY")
    store.subscribe(() => {
        const currState = store.getState();
        let currMonth = currState.filtersState.currentMonth.format("MYYYY")
        let currQuery = Object.keys(currState.filtersState.filters).sort().map(filterKey => `${filterKey}=${currState.filtersState.filters[filterKey]}`).join('&');
        let prevQuery = Object.keys(prevState.filtersState.filters).sort().map(filterKey => `${filterKey}=${prevState.filtersState.filters[filterKey]}`).join('&');
        if ((currQuery !== prevQuery && !currState.listingState.currentlyRequesting) || currState.listingState.relativeUrl !== prevState.listingState.relativeUrl) {
            prevState = store.getState();
            store.dispatch(getListing() as any);
        }
        if (currMonth !== prevMonth) {
            prevState = store.getState();
            prevMonth = currState.filtersState.currentMonth.format("MYYYY")
            store.dispatch(fetchEvents(currState.filtersState.currentMonth, currState.filtersState.filters["QueryValue"], currState.filtersState.filters["ziporcity"], currState.filtersState.filters["eventtype"]) as any);
        }

        if (document.getElementById("event-entry-js") && ((currQuery !== prevQuery && !currState.listingState.currentlyRequesting) || currState.listingState.relativeUrl !== prevState.listingState.relativeUrl)) {
            store.dispatch(fetchEvents(currState.filtersState.currentMonth, currState.filtersState.filters["QueryValue"], currState.filtersState.filters["ziporcity"], currState.filtersState.filters["eventtype"]) as any);
        }

        saveState(store.getState(), localStoreCacheKey());
    });
}

export { defaultStore };
